"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSquare = exports.Speedtrap = exports.GoogleAnalytics = exports.analyticsEvent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-underscore-dangle */

/* Analytics */

/* Component to keep analytics utility functionality centralised */

/**
 * Checks if Google Analytics exists on the page
 *
 * @return {boolean}
 */
var GoogleAnalytics = function GoogleAnalytics() {
  return window !== undefined && window.ga !== undefined && typeof window.ga === 'function';
};
/**
 * Checks if the correct Speedtrap methods exist on the page
 * depending on what envirnoment its being called in
 * Note - We currently have different method names across non-prd & prd environments hence this check
 *
 * @return {object} - To provide a boolean if is in window & string for environment
 */


exports.GoogleAnalytics = GoogleAnalytics;

var Speedtrap = function Speedtrap() {
  if (window === undefined) {
    return {
      isInWindow: false
    };
  }

  if (window.veryv9csaclick !== undefined && typeof window.veryv9csaclick === 'function' && window.veryv9csaevent !== undefined && typeof window.veryv9csaevent === 'function' && window.veryv9csaformsubmit !== undefined && typeof window.veryv9csaformsubmit === 'function' && window.veryv9csatextchange !== undefined && typeof window.veryv9csatextchange === 'function') {
    return {
      isInWindow: true,
      env: 'prd'
    };
  }

  if (window.sdgv9ppcsaclick !== undefined && typeof window.sdgv9ppcsaclick === 'function' && window.sdgv9ppcsaevent !== undefined && typeof window.sdgv9ppcsaevent === 'function' && window.sdgv9ppcsaformsubmit !== undefined && typeof window.sdgv9ppcsaformsubmit === 'function' && window.sdgv9ppcsatextchange !== undefined && typeof window.sdgv9ppcsatextchange === 'function') {
    return {
      isInWindow: true,
      env: 'nonprd'
    };
  }

  return {
    isInWindow: false
  };
};
/**
 * Checks if the string passed is empty
 *
 * @param {string} - A string param
 * @return {boolean}
 */


exports.Speedtrap = Speedtrap;

var isEmptyString = function isEmptyString(string) {
  return typeof string !== 'string' || string.trim() === '';
};

var isNum = function isNum(number) {
  return typeof number !== 'number';
};
/**
 * Checks if Contentsquare exists on the page
 *
 * @return {boolean}
 */


var ContentSquare = function ContentSquare() {
  return window !== undefined && window._uxa !== undefined;
};

exports.ContentSquare = ContentSquare;

var handleContentSquareData = function handleContentSquareData(data) {
  if (isEmptyString(data.type) || isEmptyString(data.value)) {
    console.error('AnalyticsEvent: Content Square requires an event type and value');
    return false;
  }

  if (data.type === 'setCustomVariable' && (isNum(data.slot) || isEmptyString(data.key))) {
    console.error('AnalyticsEvent: Content Square Custom Variable event requires a slot number & key value');
    return false;
  }

  if (data.type === 'trackDynamicVariable' && isEmptyString(data.key)) {
    console.error('AnalyticsEvent: Content Square Dynamic Variable event requires a key value');
    return false;
  }

  switch (data.type) {
    case 'setCustomVariable':
      window._uxa.push(['setCustomVariable', data.slot, data.key, data.value, 3]);

      break;

    case 'trackDynamicVariable':
      window._uxa.push(['trackDynamicVariable', {
        key: data.key,
        value: data.value
      }]);

      break;

    case 'trackPageview':
      window._uxa.push(['trackPageview', "".concat(window.location.pathname, "?").concat(data.value)]);

      break;

    default:
      console.error('Incorrect Content Square event type');
      break;
  }

  return true;
};
/**
 * Sends a Google Analytics event to the window.ga method
 *
 * @param {object} - An event of data
 * @return {boolean}
 */


var handleGoogleAnalyticsEvent = function handleGoogleAnalyticsEvent(event) {
  if (isEmptyString(event.category) || isEmptyString(event.action) || isEmptyString(event.label)) {
    console.error('AnalyticsEvent: Google Analytics requires object with string values for category, action and label');
    return false;
  }

  window.ga('send', 'event', event.category, event.action, event.label);
  return true;
};
/**
 * Sends a Speedtrap event to the window.SDCSAclick method
 *
 * @param {object} - An event of data
 * @return {boolean}
 */


var handleSpeedtrapEvent = function handleSpeedtrapEvent(event, speedTrapEnv) {
  if (event.data === undefined || (0, _typeof2["default"])(event.data) !== 'object') {
    console.error('AnalyticsEvent: Speedtrap requires an event object with a data object key');
    return false;
  }

  if (event.type === undefined || event.type === 'click') {
    window[speedTrapEnv === 'prd' ? 'veryv9csaclick' : 'sdgv9ppcsaclick'](_objectSpread(_objectSpread({}, event.data), {}, {
      type: 'click'
    }));
  } else if (event.type === 'event') {
    window[speedTrapEnv === 'prd' ? 'veryv9csaevent' : 'sdgv9ppcsaevent'](_objectSpread(_objectSpread({}, event.data), {}, {
      type: 'event'
    }));
  }

  return true;
};
/**
 * Pushes a Content Square page view into the _uxa object
 *
 * @param {object} - An event of data
 * @return {boolean}
 */


var handleContentSquareEvent = function handleContentSquareEvent(event) {
  if (event.csData === undefined || (0, _typeof2["default"])(event.csData) !== 'object') {
    console.error('AnalyticsEvent: Content Square requires an event object with a data object key');
    return false;
  }

  handleContentSquareData(event.csData);
  return true;
};
/**
* Sends a Google Analytics/ Speedtrap/ Contentsquare event if the platform is defined and the event object is valid
*
* @param {object} event - An event of data
* @return {boolean/function(event)} A boolean or invoked event handler function/s (handleGoogleAnalyticsEvent, handleSpeedtrapEvent, handleContentSqaureEvent)
* @example
*     analyticsEvent({
	  category: 'GA category',
	  action: 'GA action',
	  label: 'GA Label',
	  csData: {
		  type: 'setCustomVariable',
		  slot: 2,
		  key: 'New Account',
		  value: 'Cash',
	  },
	  data: {
		  name: 'Speedtrap name',
		  id: `Speedtrap ID`,
	  },
	  send: {
		  googleAnalytics: true,
		  speedtrap: true,
		  contentSquare: true
	  },
  })
*/


var analyticsEvent = function analyticsEvent(event) {
  var GoogleAnalyticsExists = GoogleAnalytics();

  var _Speedtrap = Speedtrap(),
      SpeedtrapExists = _Speedtrap.isInWindow,
      speedTrapEnv = _Speedtrap.env;

  var ContentSquareExists = ContentSquare();

  if (!GoogleAnalyticsExists && !SpeedtrapExists && !ContentSquareExists) {
    console.error('AnalyticsEvent: no analytics platform detected');
    return false;
  }

  if ((0, _typeof2["default"])(event) !== 'object') {
    console.error('AnalyticsEvent: requires object as parameter');
    return false;
  }

  if (event.send !== undefined && (event.send.googleAnalytics === false && event.send.speedtrap === false && event.send.contentSquare === false || event.send.googleAnalytics === false && event.send.speedtrap === undefined && event.send.contentSquare === undefined)) {
    console.error('AnalyticsEvent: no platform set in send object');
    return false;
  }

  if (GoogleAnalyticsExists && SpeedtrapExists && ContentSquareExists && event.send !== undefined && event.send.googleAnalytics === true && event.send.speedtrap === true && event.send.contentSquare === true) {
    return handleGoogleAnalyticsEvent(event) && handleSpeedtrapEvent(event, speedTrapEnv) && handleContentSquareEvent(event);
  }

  if (GoogleAnalyticsExists && SpeedtrapExists && event.send !== undefined && event.send.googleAnalytics === true && event.send.speedtrap === true) {
    return handleGoogleAnalyticsEvent(event) && handleSpeedtrapEvent(event, speedTrapEnv);
  }

  if (GoogleAnalyticsExists && ContentSquareExists && event.send !== undefined && event.send.googleAnalytics === true && event.send.contentSquare === true) {
    return handleGoogleAnalyticsEvent(event) && handleContentSquareEvent(event);
  }

  if (GoogleAnalyticsExists && (event.send === undefined || event.send.googleAnalytics === true)) {
    return handleGoogleAnalyticsEvent(event);
  }

  if (SpeedtrapExists && event.send !== undefined && event.send.speedtrap === true) {
    return handleSpeedtrapEvent(event, speedTrapEnv);
  }

  if (ContentSquareExists && event.send !== undefined && event.send.contentSquare === true) {
    return handleContentSquareEvent(event);
  }

  return true;
};

exports.analyticsEvent = analyticsEvent;